import { Navigate, useLocation } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { createRerouteRegex } from "App/routes/pageNames";
import { LegacyPagePaths } from "App/routes/paths";
import { useLiveOpsPathing } from "Pages/liveOps/useLiveOpsPathing";

import { taskPathResources } from "./Pages/taskPaths";

export default function TasksRoutingPage(): JSX.Element {
    return <RVNestedRoutingPage />;
}

export function TasksRerouter(): JSX.Element {
    const location = useLocation();
    const { tasksBasePath } = useLiveOpsPathing();
    const pathAfterTasks = location.pathname.replace(createRerouteRegex(LegacyPagePaths.tasks), "");

    // If there's a nested path, preserve it; otherwise use the base path
    const newPath = pathAfterTasks
        ? `${tasksBasePath.replace(`/${taskPathResources.upcoming}`, "")}/${pathAfterTasks}${location.search}${location.hash}`
        : `${tasksBasePath}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}

export function RecentTasksRerouter(): JSX.Element {
    const location = useLocation();
    const { recentTasksBasePath } = useLiveOpsPathing();
    const newPath = `${recentTasksBasePath}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
